module.exports = __webpack_public_path__ + "static/media/af.d8fb0d22.svg";